<div class="cell auto grid-y cell-block-y blockContent grid-padding-y" *ngIf="study">
    <p [i18nKey]="'studies.taxes.description.1'"></p>
    <p [i18nKey]="'studies.taxes.description.2'"></p>
    <h3 [i18nKey]="'studies.taxes.title.1'"></h3>
    <table class="cell shrink">
        <thead>
        <tr class="_titlePartTable">
            <th class="_numberColumn"[i18nKey]="'studies.taxes.result'"></th>
            <th class="_numberColumn"[i18nKey]="'studies.taxes.retained.earnings'"></th>
            <th class="_numberColumn"[i18nKey]="'studies.taxes.taxable.income'"></th>
            <th class="_numberColumn"[i18nKey]="'studies.taxes.income.taxes'"></th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td class="_number">{{study.grossResult | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_number">{{study.retainedEarnings | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_number">{{study.taxableIncome | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_number">{{study.incomeTax | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
        </tr>
        </tbody>
    </table>

    <h3 [i18nKey]="'studies.taxes.title.2'"></h3>
    <p [i18nKey]="'studies.taxes.description.3'"></p>
    <p [i18nKey]="'studies.taxes.description.4'"></p>
    <p [i18nKey]="'studies.taxes.description.5'"></p>
    <kiwi-spacer [size]="16"></kiwi-spacer>
    <h3 [i18nKey]="'studies.taxes.title.3'"></h3>
    <p [i18nKey]="'studies.taxes.description.6'"></p>
    <kiwi-spacer [size]="16"></kiwi-spacer>
    <h3 [i18nKey]="'common.taxes.vat.output'"></h3>
    <table class="cell shrink">
        <thead>
        <tr class="_titlePartTable">
            <th></th>
            <th class="_numberColumn"[i18nKey]="'studies.taxes.income.ht'"></th>
            <th class="_numberColumn"[i18nKey]="'common.taxes.vat.output'"></th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td [i18nKey]="'studies.taxes.income.dishes'"></td>
            <td class="_number">{{study.dishesTurnoverExcludingTaxes | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_number">{{study.dishesTurnoverTaxes | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
        </tr>
        <tr>
            <td [i18nKey]="'studies.taxes.income.wines'"></td>
            <td class="_number">{{study.winesTurnoverExcludingTaxes | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_number">{{study.winesTurnoverTaxes | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
        </tr>
        <tr>
            <td [i18nKey]="'studies.taxes.income.other.operating'"></td>
            <td class="_number">{{study.otherOperatingProductsExcludingTaxes | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_number">{{study.otherOperatingProductsTaxes | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
        </tr>
        <tr>
            <td [i18nKey]="'studies.taxes.income.layout'"></td>
            <td class="_number">{{study.layoutSellingIncomeExcludingTaxes | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_number">{{study.layoutSellingIncomeTaxes | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
        </tr>
        <tr>
            <td [i18nKey]="'common.total'"></td>
            <td class="_number">{{study.incomeTotalExcludingTaxes | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_number">{{study.incomeTotalTaxes | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
        </tr>
        </tbody>
    </table>
    <kiwi-spacer [size]="16"></kiwi-spacer>
    <h3 [i18nKey]="'common.taxes.vat.input'"></h3>
    <table class="cell shrink">
        <thead>
        <tr class="_titlePartTable">
            <th></th>
            <th class="_numberColumn"[i18nKey]="'studies.taxes.charges.ht'"></th>
            <th class="_numberColumn"[i18nKey]="'common.taxes.vat.input'"></th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td [i18nKey]="'studies.taxes.charges.dishes'"></td>
            <td class="_number">{{study.ingredientsPurchasesExcludingTaxes | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_number">{{study.ingredientsPurchasesTaxes | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
        </tr>
        <tr>
            <td [i18nKey]="'studies.taxes.charges.wines'"></td>
            <td class="_number">{{study.winesPurchasesExcludingTaxes | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_number">{{study.winesPurchasesTaxes | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.taxes.charges.external'"></td>
            <td class="_number">{{study.externalLoadsExcludingTaxes | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_number">{{study.externalLoadsTaxes | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
        </tr>
        <tr>
            <td [i18nKey]="'studies.taxes.charges.other.operating'"></td>
            <td class="_number">{{study.otherOperatingChargesExcludingTaxes | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_number">{{study.otherOperatingChargesTaxes | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
        </tr>
        <tr>
            <td [i18nKey]="'studies.taxes.charges.layout'"></td>
            <td class="_number">{{study.layoutPurchaseCostExcludingTaxes | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_number">{{study.layoutPurchaseCostTaxes | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
        </tr>
        <tr>
            <td [i18nKey]="'common.total'"></td>
            <td class="_number">{{study.chargesTotalExcludingTaxes | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_number">{{study.chargesTotalTaxes | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
        </tr>
        </tbody>
    </table>
</div>
